import React from "react";
import { Link } from "react-router-dom";
import { BsSun, BsFillMoonFill } from "react-icons/bs";
import { noormohammadDarkLogo, noormohammadLightLogo } from "../../assets";
import noorMohammadResume from "../../assets/docs/Noor Mohammad resume.pdf";
import List from "../layout/List";
import ListItem from "../layout/ListItem";

const Header = ({ theme, themeChanger }) => {
  return (
    <nav
      className={`w-full h-full ${
        theme === "dark" ? "bg-darkBgColor " : "bg-lightBgColor "
      } top-0 sticky z-50`}
    >
      <div
        className={`${
          theme === "dark"
            ? "bg-darkBgColor border-darkLineColor"
            : "bg-lightBgColor border-lightLineColor"
        } max-w-6xl mx-auto px-8 xl:px-0 z-50 py-4 flex justify-between items-center border-b-[1px]`}
      >
        <Link to="/">
          <div>
            <img
              className="bg-transparent w-72"
              src={
                theme === "dark" ? noormohammadDarkLogo : noormohammadLightLogo
              }
              alt="noormohammad"
            />
          </div>
        </Link>
        <div className="hidden lgl:inline-flex">
          <List theme={theme}>
            <Link to="/">
              <ListItem theme={theme} itemname="Home" />
            </Link>
            <Link to="/projects">
              <ListItem theme={theme} itemname="Projects" />
            </Link>
            <Link to="/contact">
              <ListItem theme={theme} itemname="Contact" />
            </Link>
            <a href={noorMohammadResume} target="_blank" rel="noreferrer">
              <ListItem theme={theme} itemname="Hire Me" />
            </a>
          </List>
        </div>
        <div
          onClick={themeChanger}
          className={`cursor-pointer transition-opacity duration-300 flex w-10 h-10 font-semibold rounded-full flex-row justify-center items-center `}
        >
          {theme === "dark" ? (
            <BsSun
              className={`text-2xl ${theme === "dark" && "text-yellow-500"}`}
            />
          ) : (
            <BsFillMoonFill
              className={`text-2xl ${
                theme === "light" && "text-lightTextDesignColor"
              }`}
            />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;
